import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { SessionState, AuthenticationState } from "./type";
import $inoe from "@/config";

export const getApiUser: Getter<SessionState, RootState> = state => state.session.apiUser;
export const getSession: Getter<SessionState, RootState> = state => state.session;
export const isAuthenticated: Getter<SessionState, RootState> = state => state.session.status === AuthenticationState.Success;

export const getNoSession: Getter<SessionState, RootState> = state => state.noSession;
export const getLocalDBStatus: Getter<SessionState, RootState> = state => state.localDBStatus;
export const isLocalDBComplete: Getter<SessionState, RootState> = state => state.isLocalDBComplete;
export const storeWillUpdate: Getter<SessionState, RootState> = state => state.storeWillUpdate;

export const getMemDBStatus: Getter<SessionState, RootState> = state => state.memDBStatus;
export const getMemDBStats: Getter<SessionState, RootState> = state => state.memDBStats;
export const getProgress: Getter<SessionState, RootState> = state => state.progress;
export const getMaxDbSize: Getter<SessionState, RootState> = state => state.maxDbSize;
export const getInterval: Getter<SessionState, RootState> = state => state.interval;
export const getIsOffline: Getter<SessionState, RootState> = state => state.isOffline;

export const getters:GetterTree<SessionState,RootState> = {
    getApiUser,
    getSession,
    isAuthenticated,
    getNoSession,
    isLocalDBComplete,
    storeWillUpdate,
    getLocalDBStatus,
    getMemDBStatus,
    getMemDBStats,
    getProgress,
    getMaxDbSize,
    getInterval,
    getIsOffline
}
